import { SyncedRemoteCollectionStore } from '@softline/core';
import { Subkunde } from '../types/subkunde';

export const SubkundenStore = SyncedRemoteCollectionStore.create<Subkunde>();
